import type { ContentProps } from '../../content.types'
import * as Comp from './content-actions.styles'

import {
  DISPLAY_NAME,
  type ScopedProps,
  useContentContext,
} from '../../content'

type ContentActionsProps = ContentProps

export function ContentActions(props: ContentActionsProps) {
  const { children, testID, __scopeContent } =
    props as ScopedProps<ContentActionsProps>

  const { type } = useContentContext(DISPLAY_NAME, __scopeContent)

  if (type !== 'title') {
    return
  }

  return <Comp.Actions testID={testID}>{children}</Comp.Actions>
}
